import { Box, Flex, PopperHeader, Stack, VStack, Z_INDEX } from '@talos/kyoko';
import styled from 'styled-components';

//Same animation duration as order-form feedback card.
export const ANIMATION_DURATION = 300;

export const TransferConfirmationWrapper = styled(Stack)<{ isVisible: boolean }>`
  transition:
    transform ${ANIMATION_DURATION}ms,
    opacity ${ANIMATION_DURATION}ms;
  transform: translateY(0%);
  opacity: 1;
  box-shadow: ${({ theme }) => theme.boxShadowDraggedItem};

  ${({ isVisible }) =>
    !isVisible &&
    `
    transform: translateY(100%);
    opacity: 0;
  `}

  @starting-style {
    transform: translateY(100%);
    opacity: 0;
  }
`;
TransferConfirmationWrapper.defaultProps = {
  background: 'backgroundPopover',
  bottom: 0,
  position: 'absolute',
  right: 0,
  left: 0,
  zIndex: 2,
  maxHeight: '100%',
};

export const TransferConfirmationPopperHeader = styled(PopperHeader)`
  && {
    min-height: ${({ theme }) => theme.spacing32}px;
    padding: ${({ theme }) => theme.spacing4}px;
    padding-left: ${({ theme }) => theme.spacing12}px;
  }
`;

export const TransferConfirmationContent = styled(Box)``;
TransferConfirmationContent.defaultProps = {
  background: 'backgroundPopover',
  overflowY: 'auto',
  overflowX: 'hidden',
  flex: '1 1 auto',
  p: 'spacing16',
};

export const TransferConfirmationOverlay = styled(VStack)<{ isVisible: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${Z_INDEX.modal};
  opacity: 1;
  transition: opacity ${ANIMATION_DURATION}ms;
  background: ${({ theme }) => theme.backgroundOverlay};

  @starting-style {
    opacity: 0;
  }
`;

export const TransferConfirmationActions = styled(Flex)`
  z-index: 2;
  flex: 0 0 auto;
  padding-bottom: ${({ theme }) => `calc(${theme.spacing8}px + env(safe-area-inset-bottom))`};

  &:last-child {
    border-top: ${({ theme }) => `1px solid ${theme.colors.gray['000']}`};
  }

  button {
    width: 100%;
  }
`;
TransferConfirmationActions.defaultProps = {
  px: 'spacing12',
  pt: 'spacing8',
};
